import {
  HttpManager,
  whenRequestWithError,
  whenResponseWithError,
  RequestConfig,
  ApiError,
  RequestHeaders,
  ResponseError
} from './httpManager'

const httpManager = new HttpManager()

export {
  httpManager,
  whenRequestWithError,
  whenResponseWithError,
  RequestConfig,
  ApiError,
  RequestHeaders,
  ResponseError
}
